import { Component, OnInit, Input, SimpleChanges, forwardRef } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { MarvSelectComponent, MarvSelectItem } from '@marv/components';
import { CustomerSectorService } from '@app/services';

@Component({
    selector: 'app-sector-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [forwardRef(() => MarvSelectComponent)]
})
export class SectorSelectComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelSelect: string = this.translateService.instant('SECTOR');
    @Input({alias : 'icon', required : false}) iconSelect: string = 'trail-sign-outline';
    @Input({alias : 'formName', required : false}) formName: string|number = 'sectorId';
    @Input({alias : 'errorText', required : false}) errorText: string = '';
    @Input({alias : 'multiple', required : false}) multiple: boolean = false; 
    @Input({alias : 'displayItemsSelected', required : false}) displayItemsSelected: boolean = false;
    @Input({alias : 'sectors', required : false}) sectors: Array<MarvSelectItem>;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;

    items: Array<MarvSelectItem> = [];

    constructor(
        public translateService: TranslateService
    ) { }

    async ngOnInit() {
        let items: Array<MarvSelectItem> = [];
        if(typeof this.sectors !== 'undefined'){
            items = this.sectors;
        }
        else{
            let sectors = CustomerSectorService.Sectors;
            if(sectors){
                for(let sector of sectors){
                    items.push(new MarvSelectItem(sector.name, sector.id));
                }
            }
        }
        this.items = items;
    }

    async ngOnChanges(changes: SimpleChanges) {      
        if(changes['sectors'] && changes['sectors'].currentValue){ 
            if(typeof this.sectors !== 'undefined'){
                this.items = this.sectors;
            }
        }
    }
}
